<template>
  <div class="Foot" v-if="customFoot" :style="`background: url(${customFoot.backgroundImgUrl})`">
    <div class="company">
      <span>{{ customFoot.company }}</span>
      <!-- <span>版权所有@2017<a href="http://www.miitbeian.gov.cn/">粤ICP备16067888号</a></span> -->
      <span v-if="customFoot.copyright">{{ customFoot.copyright }}
        <a href="javascript:void(0)" class="tolink" @click="jumpIcp()">{{ customFoot.icp }}</a>
      </span>
    </div>
  </div>
  <div class="Foot" v-else>
    <div class="company">
      <span>广东艾科智泊科技股份有限公司</span>
      <!-- <span>版权所有@2017<a href="http://www.miitbeian.gov.cn/">粤ICP备16067888号</a></span> -->
      <span>版权所有@2017<a class="tolink" onclick="window.open('https://beian.miit.gov.cn')">粤ICP 备16040317号</a></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customFoot: '',
    };
  },
  created() {
    if (this.$root.customConfig.foot && Object.keys(this.$root.customConfig.foot).length > 0) {
      this.customFoot = this.$root.customConfig.foot;
    }
  },
  mounted() {
    // this.initFoot();
    // console.log(this.$route)
  },
  methods: {
    initFoot() {
      console.log(this.$route.name == "Help", this.$route.name == "Support");
      if (this.$route.name == "Help") {
        $(".Foot ").css("position", "absolute");
      } else {
        $(".Foot ").css("position", "static");
      }
    },
    jumpIcp() {
      console.log(555)
      var tempwindow=window.open('_blank'); // 先打开页面
      tempwindow.location = this.customFoot.icpUrl; // 后更改页面地址
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.Foot {
  position: static;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: url(../assets/images/libs/logo_footer.png);
  background-repeat: no-repeat !important;
  /* background-size: 112px 36px; */
  background-position: 10% 50% !important;
  background-color: #eef1f6 !important;
  padding: 25px 0;
  border-top: 1px solid #ccc;
  width: 100%;
  .company {
    width: 230px;
    display: flex;
    flex-direction: column;
    margin-right: 10%;
    // padding-right: 10%;
    span {
      font-size: 12px;
      color: #999;
      padding: 2px 0;
    }
    .tolink{
	color: #999;
}
.tolink a:hover {
    color: #fff;
}
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Foot.vue